import { Component, ElementRef, Inject, Injector, HostListener } from '@angular/core';
import { NgbActiveModal, NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AppComponentBase } from '../../../../services/AppComponentBase';




@Component({
    selector: "modal-ScannerTrialInfoImages",
    template: require('./ScannerTrialInfoImages.component.html'),
    styles: [require('./ScannerTrialInfoImages.component.css')]
})

export class ScannerTrialInfoImages extends AppComponentBase
 {

    constructor(

        injector: Injector,
        public activeModal: NgbActiveModal,
    ) {
        super(injector);
    }

   private _dontShowAgain: boolean = false;
    public get dontShowAgain (): boolean {
        return this._dontShowAgain;
    }
    public set dontShowAgain ( value: boolean ) {
        this._dontShowAgain = value;

        if(value == true)
        {
            this.workspace.cookieService.setCookie("scannerInfoDontshow","1",10000);
        }
        else
        {
            this.workspace.cookieService.deleteCookie("scannerInfoDontshow");
        }

    }

    private _trueinfo: boolean = false;
    public get trueinfo(): boolean {
        return this._trueinfo;
    }
    public set trueinfo(value: boolean) {
        this._trueinfo = value;
    }
}


